<template>
  <el-dialog
    title="Create New Carrier"
    :visible.sync="isShowing"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
  >
    <div>
      <CarrierDetail
        v-if="step == 1"
        ref="carrierDetail"
        :form-data="formData.detailData"
      />
      <Label
        v-if="step == 2"
        ref="label"
        :form-data="formData.shipperData"
      />
      <Consignment
        v-if="step == 3"
        ref="consignment"
        :form-data="formData.consignmentData"
      />
      <Manifest
        v-if="step == 4"
        ref="manifest"
        :form-data="formData.manifestData"
      />
      <Pickup
        v-if="step == 5"
        ref="pickup"
        :form-data="formData.pickupData"
      />
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShowing = false">
        Cancel
      </el-button>
      <el-button
        type="default"
        :loading="isSaving"
        @click.native="previousStep"
      >
        Previous
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="nextStep"
      >
        Next {{ step }}/5
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import CarrierDetail from '@/components/Application/Manage/Carriers/Carrier/Detail'
import Label from '@/components/Application/Manage/Carriers/Carrier/Label'
import Consignment from '@/components/Application/Manage/Carriers/Carrier/Consignment'
import Manifest from '@/components/Application/Manage/Carriers/Carrier/Manifest'
import Pickup from '@/components/Application/Manage/Carriers/Carrier/Pickup'
export default {
  components: {
    CarrierDetail,
    Label,
    Consignment,
    Manifest,
    Pickup
  },
  data () {
    return {
      isShowing: false,
      isSaving: false,
      step: 1,
      isFullscreen: false,
      formData: {
        detailData: {
          enabled: false,
          name: null,
          fullName: null,
          phone: null,
          address: null,
          suburb: null,
          state: null,
          postcode: null
        },
        shipperData: {
          labelTemplate: null,
          template: null,
          printConnote: false,
          printLabel: false
        },
        consignmentData: {
          prefixRequired: false,
          length: null,
          prefixDef: null,
          minDef: null,
          maxDef: null
        },
        manifestData: {
          prefixRequired: false,
          length: null,
          prefixDef: null,
          minDef: null,
          maxDef: null
        },
        pickupData: {
          pickupType: null,
          pickupTemplate: null,
          pickupCutoff: null

        },
        page: 1,
        perPage: 10
      }
    }
  },
  methods: {
    showDialog () {
      this.isShowing = true
    },
    closeDialog () {
      this.isShowing = false
    },
    nextStep () {
      switch (this.step) {
        case 1:
          this.$refs.carrierDetail.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 2
            }
          })
          break
        case 2:
          this.$refs.label.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 3
            }
          })
          break
        case 3:
          this.$refs.consignment.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 4
            }
          })
          break
        case 4:
          this.$refs.manifest.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 5
            }
          })
          break
        case 5:
          this.$refs.pickup.$refs.form.validate((valid) => {
            if (valid) {
              this.isSaving = true
              this.createNewCarrier()
            }
          })
          break
      }
    },
    previousStep () {
      if (this.step > 1) {
        this.step--
      } else {
        this.step = 1
      }
    },
    createNewCarrier () {
      this.$sdk.carrier.create({
        address: this.formData.detailData.address,
        con_length: this.formData.consignmentData.length,
        con_template: this.formData.shipperData.template,
        config_con_max_def: this.formData.consignmentData.maxDef,
        config_con_min_def: this.formData.consignmentData.minDef,
        config_con_prefix_def: this.formData.consignmentData.prefixDef,
        config_con_prefix_req: this.formData.consignmentData.prefixRequired,
        config_man_max_def: this.formData.manifestData.maxDef,
        config_man_min_def: this.formData.manifestData.minDef,
        config_man_prefix_def: this.formData.manifestData.prefixDef,
        config_man_prefix_req: this.formData.manifestData.prefixRequired,
        default_fuel_group: null,
        default_service: null,
        default_zone_parent: false,
        edi_acc_req: false,
        edi_accepts_rtp: false,
        edi_siteid_req: false,
        edi_sysid_req: false,
        edi_template: null,
        enabled: false,
        full_name: this.formData.detailData.fullName,
        inv_template: null,
        label_template: this.formData.shipperData.labelTemplate,
        manifest_length: this.formData.manifestData.length,
        name: this.formData.detailData.name,
        phone: this.formData.detailData.phone,
        pickup_cutoff: this.formData.pickupData.pickupCutoff,
        pickup_template: this.formData.pickupData.pickupTemplate,
        pickup_type: this.formData.pickupData.pickupType,
        postcode: this.formData.detailData.postcode,
        print_connote: this.formData.shipperData.printConnote,
        print_label: this.formData.shipperData.printLabel,
        state: this.formData.detailData.state,
        terms: [],
        town: this.formData.detailData.suburb,
        transfer_type: false
      }, builder => {
        builder.include = ['carrier_services']
      }).then(() => {
        this.$message({ message: 'Successfully saved', type: 'success' })
        this.isSaving = false
      })
        .finally(() => {
          this.closeDialog()
          this.isSaving = false
          this.$emit('refreshUpdate')
        })
    }
  }
}
</script>
